<template>
  <div class="alert">
    <el-dialog
      :visible.sync="show"
      :width="width"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="'支付提示'"
      :show-close="showClose"
    >
      <div class="container" v-loading="loading">
        <div class="content">
          <img :src="iconImg" />
          <div class="contentText">
            <span
              class="des"
              v-html="'完成订单支付操作后，根据支付情况选择'"
            ></span>
          </div>
        </div>
        <div class="btn_box">
          <el-button class="btn cancel" type="danger" @click="confirm"
            >支付完成</el-button
          >
          <el-button class="btn" @click="cancel">支付出现问题，重试</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

import { orderInfo, batchPrint } from "api/api";

export default {
  data() {
    return {
      loading: false
    };
  },
  props: {
    width: {
      default: "412px",
      type: String
    },
    iconImg: {
      default: require("@/assets/img/share/error.png"),
      type: String
    },
    showClose: {
      default: true,
      type: Boolean
    },
    show: {
      type: Boolean,
      require: true,
      default: false
    },
    orderId: {
      type: String || null,
      require: true,
      default: null
    },
    order: {
      type: Object || null,
      require: true,
      default: null
    }
  },
  methods: {
    ...mapMutations("batch", [
      "SET_UPLOAD_LISTS",
      "SET_ORDER",
      "SET_IS_UPLOADING"
    ]),
    handleClose() {
      this.$emit("update:show", false);
    },
    confirm() {
      this.loading = true;
      orderInfo({ orderId: this.orderId }).then(({ data }) => {
        switch (data.orderPayStatus) {
          case 1:
            this.loading = false;
            this.$emit("update:show", false);
            return this.$emit("showError")
          case 2:
            // 支付成功了
            const printNoList = this.order.settingParams.map(
              item => item.printNo
            );
            batchPrint(printNoList).then(() => {
              this.loading = false;
              this.$emit("update:show", false);
              this.$emit("updatePrintingList", true);
              this.SET_UPLOAD_LISTS([]);
              this.SET_ORDER(null);
              this.SET_IS_UPLOADING(false);
            });
            break;
          default:
            this.loading = false;
            this.$emit("update:show", false);
            return this.$emit("showError");
        }
      });
    },
    cancel() {
      this.$emit("update:show", false);
      this.$emit("togglePayBillModal");
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
}
.alert {
  ::v-deep {
    .el-dialog__body {
      padding: 17px 20px 20px;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 19px;
      letter-spacing: 0px;
      color: #333333;
    }
  }
}
.content {
  padding: 0 20px;
  display: flex;
  align-items: center;
  width: 100%;
  .contentText {
    flex: auto;
    width: 0;
  }
  img {
    width: 28px;
    height: 28px;
    margin-right: 13px;
  }
  .subtitle {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 27px;
    letter-spacing: 0px;
    color: #333333;
  }
  .des {
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0px;
    color: #666666;
    line-height: 24px;
  }
}
.btn_box {
  display: flex;
  width: 100%;
  margin-top: 35px;
  padding: 0 60px 20px;
  flex-direction: flex-end;
  justify-content: space-between;
}
.cancel {
  color: white;
  border-color: white;
}
.btn {
  height: 32px;
  line-height: 32px;
  padding: 0 15px;
}
</style>
